import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editor", "modal"]

  insertPrompt(event) {
    event.preventDefault()
    this.chain.insertPrompt().run()
  }

  insertTemplate(event) {
    const { template } = event.currentTarget.dataset
    const content = autoloadPrompts(template)
    this.chain.insertContent(content).run()
    this.modalTarget.close()
  }

  get chain() {
    return this.editor.chain().focus()
  }

  get editor() {
    return this.editorElement.editor
  }

  get editorElement() {
    return this.editorTargets[0] || this.element.closest("rich-text-area")
  }
}

function autoloadPrompts(html) {
  const { body } = new DOMParser().parseFromString(html, "text/html")
  for (const element of body.querySelectorAll("rich-text-prompt")) {
    element.toggleAttribute("autoload", true)
  }
  return body.innerHTML
}
